var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1074,
    height: 642,
    viewBox: "0 0 1074 642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3131_10361)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1074,
    height: 642,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.478 -280.702C872.297 -262.363 913.802 -219.581 931.693 -167.585C950.862 -111.878 945.907 -49.8588 917.727 1.91234C888.682 55.2719 840.445 102.812 780.237 110.662C723.973 117.997 679.906 71.0039 633.057 39.028C591.235 10.4833 539.855 -12.811 527.393 -61.9122C514.972 -110.852 540.275 -161.494 572.236 -200.61C599.691 -234.212 643.773 -241.554 685.053 -254.873C730.524 -269.543 775.458 -296.635 820.478 -280.702Z",
    fill: "#FFD550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1031.33 153.479C1094.57 162.291 1142.62 204.089 1190.41 246.422C1242.96 292.97 1308.71 335.667 1315.85 405.503C1323.42 479.524 1281.5 550.542 1226.65 600.825C1174.03 649.069 1102.45 672.565 1031.33 666.35C965.593 660.606 917.963 611.842 867.402 569.435C808.93 520.392 729.767 481.234 720.331 405.503C710.334 325.277 757.921 245.803 820.733 194.903C878.517 148.076 957.669 143.213 1031.33 153.479Z",
    fill: "#FFD550"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3131_10361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1074,
    height: 642,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBg);
export default __webpack_public_path__ + "static/media/wallet_bg.cd46db615898b3fbb0abe1e7a2af4b9c.svg";
export { ForwardRef as ReactComponent };